import { useEffect } from "react";
import { fontStack, loadFonts } from "../../lib/fonts";

export const paint = (c) => {
  if (!c?.c1) return undefined;
  if (c.grad && c.c2) return { backgroundImage: `linear-gradient(90deg, ${c.c1}, ${c.c2})`, WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent", paddingRight: "0.08em" };
  return { color: c.c1 };
};

export const fluid = (px) => `clamp(${Math.round(px * 0.62)}px, ${((px / 1280) * 100).toFixed(2)}vw, ${px}px)`;

const boxStyle = (s) => ({
  fontFamily: fontStack(s.font),
  ...(s.size ? { fontSize: fluid(s.size), lineHeight: 1.15 } : {}),
  ...(s.align ? { display: "block", textAlign: s.align, width: "100%" } : {}),
});

export function StyledText({ text = "", style, tail = 1, as: Tag = "span", className = "", bClass = "", testid }) {
  const s = style || {};
  useEffect(() => { loadFonts([s.font], `font-${s.font}`); }, [s.font]);
  const w = String(text).split(" ");
  const cut = w.length > tail ? w.length - tail : w.length;
  const a = w.slice(0, cut).join(" ");
  const b = w.slice(cut).join(" ");
  return (
    <Tag className={className} style={boxStyle(s)} data-testid={testid}>
      <span style={paint(s.a)}>{a}</span>
      {b && <> <span className={s.b?.c1 ? "" : bClass} style={paint(s.b)}>{b}</span></>}
    </Tag>
  );
}
